import { Text } from "@/elements"
import React from "react"

interface InputErrorTextProps {
  text: string
}

export const InputErrorText: React.FC<InputErrorTextProps> = ({ text }) => {
  return (
    <Text className="text-red-dark" variant="body3">
      * {text}
    </Text>
  )
}
